// extracted by css-extract-rspack-plugin
export default {"text":"_485aa0ef"};